export const SET_LOADING = 'SET_LOADING';
export const CONVERT = 'CONVERT';
export const CONVERT_ERROR = 'CONVERT_ERROR';